const palette = {
  dark: {
    text: '#808080',
    background: '#333',
    accent: '#9ACD32',
    button: '#f2f2f2',
    buttonText: '#000',
    buttonHoverText:'#fff',
    themeSwitch: '#333',
    shadowColor:'rgba(184, 247, 180, 0.2)',
    menuWrapper:'rgba( 180, 180, 180, 0.6)',
  },
  light: {
    text: '#000',
    background: '#f2f2f2',
    accent: '#9ACD32',
    button: '#808080',
    buttonText: '#fff',
    buttonHoverText:'#000',
    themeSwitch: '#d3d3d4',
    shadowColor: 'rgba(0, 5, 97, 0.2)',
    header:'#808080',
    menuWrapper: 'rgba(80, 80, 80, 0.7)'
  },
  icon:{
    primary: '#111',
    accent:'#9ACD32'
  }
}

export default palette;



